import { createAction } from '@reduxjs/toolkit';

import { AgentTouristDraft, AgentTouristPatch } from '../../modules/b2b/api';

export const fetchB2BOrdersAction = createAction<
  | {
      query?: string;
      page?: number;
      perPage?: number;
    }
  | undefined
>('FETCH_B2B_ORDERS');

export const selectB2BOrderAction = createAction<{ id: string }>(
  'SELECT_B2B_ORDER'
);

export const createB2BOrderTouristAction = createAction<{
  orderId: string;
  tourist: AgentTouristDraft;
}>('CREATE_B2B_ORDER_TOURIST');

export const updateB2BOrderTouristAction = createAction<{
  orderId: string;
  touristId: string;
  tourist: AgentTouristPatch;
}>('UPDATE_B2B_ORDER_TOURIST');

export const deleteB2BOrderTouristAction = createAction<{
  orderId: string;
  touristId: string;
}>('DELETE_B2B_ORDER_TOURIST');
